import api from '@/api';
import {Action, Module, Mutation, VuexModule} from 'vuex-module-decorators';

@Module
export default class CreateModule extends VuexModule {
    _recommendProducts: any = {
        favorTypeIds: [],
        recommendTypes: [],
    };

    get recommendProductsResult() {
        return this._recommendProducts;
    }

    @Mutation
    UP_RECOMMEND_PRODUCTS(recommendProducts: any) {
        this._recommendProducts = recommendProducts;
    }

    // https://stackoverflow.com/questions/54127423/vuex-module-decorator-modifying-state-inside-an-action
    @Action({rawError: true})
    async GET_RECOMMEND_PRODUCTS() {
        try {
            const result = await api.getRecommendProductsV2();
            this.context.commit('UP_RECOMMEND_PRODUCTS', result.data.result);
        }
        catch (error) {
            console.error(error);
        }
    }
}
